export default __webpack_public_path__ + "static/Gotham-Medium-206f43beba59a76337868350b922a8b6.woff2";